import { get } from 'microcosm'
import React from 'react'
import { object, bool } from 'prop-types'
import withChartBreakpoint from 'lib/components/charts/with-chart-breakpoint'
import { ANIMATE } from './constants'
import '../../styles/components/chart.css'

class ChartContainer extends React.PureComponent {
  static defaultProps = {
    animate: true,
    title: null,
    desc: null,
    width: 0,
    height: 0
  }

  static contextTypes = {
    animationManager: object
  }

  static childContextTypes = {
    animate: bool
  }

  getChildContext() {
    return {
      animate:
        ANIMATE &&
        this.props.animate &&
        get(this.context.animationManager, 'enabled', true)
    }
  }

  componentDidMount() {
    this.context.animationManager &&
      this.context.animationManager.subscribe(() => {
        if (!this.unmounting) this.forceUpdate()
      })
  }

  componentWillUnmount() {
    this.unmounting = true
  }

  getClassName() {
    const { breakpoint, forceSize } = this.props

    let className = 'chart'
    let size = forceSize || breakpoint

    if (size) {
      className += ' -' + size
    }

    return className
  }

  render() {
    const { children, title, desc, width, height } = this.props

    const className = this.getClassName()
    const viewBox = `0 0 ${width} ${height}`

    return (
      <svg
        className={className}
        viewBox={viewBox}
        height={height}
        width={width}
        role="img"
        aria-labelledby="title desc"
      >
        <title id="title">{title}</title>
        <desc id="desc">{desc}</desc>
        {children}
      </svg>
    )
  }
}

export default withChartBreakpoint(ChartContainer)



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/container.js